var _rect, _rect2, _path, _circle, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 192,
    x: 80,
    y: 112,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    rx: 32,
    ry: 32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 128,
    x: 80,
    y: 304,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    rx: 32,
    ry: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    d: "M400 112H112a32.09 32.09 0 0 1-32-32h0a32.09 32.09 0 0 1 32-32h288a32.09 32.09 0 0 1 32 32h0a32.09 32.09 0 0 1-32 32M144 432v22a10 10 0 0 1-10 10h-28a10 10 0 0 1-10-10v-22Zm272 0v22a10 10 0 0 1-10 10h-28a10 10 0 0 1-10-10v-22Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 368,
    cy: 368,
    r: 16,
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 368,
    r: 16,
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    d: "M256 112v192M80 80v288M432 80v288"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusWhite);
export default __webpack_public_path__ + "static/media/bus-white.a26c1c78830814155e5df17e9f7025d2.svg";
export { ForwardRef as ReactComponent };